import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddRegionLookupListFormValues } from '../../../../../interfaces/lookup/region';
import { IAddRegion } from '../../../../../interfaces/lookup/region/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addRegion } from '../../../../../store/lookupSlice/LookupActions';

export const RegionLookupListAdd = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddRegionLookupListFormValues) => {
        const body: IAddRegion = {
            ...(values as any),
        };

        dispatch(addRegion(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.region.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/region', { replace: true });
        }
    }, [lookupSlice.detailsPage.region.createStatus]);

    return (
        <Form
            form={form}
            name="region-lookup-add"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage region lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Region',
                        path: '/admin/lookup-lists/region',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/region/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.region.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.region.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.region.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.region.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.region.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.region.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.region.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.region.fetchStatus} about={'Region'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">Region option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input maxLength={10} />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
